import {
  SectionType,
  SectionTypeStructureFieldList,
} from '@betterfunnel/types';
import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import IconButton from './Common/IconButton';
import QuillField from './QuillField';
import { EditStructuredSectionItemModal } from './SectionStructureForm/EditStructuredSectionItemModal';
import SortableList from './SortableList';

export interface ItemWithId {
  id: string;
  [key: string]: any;
}

interface Props<T extends ItemWithId> {
  title?: string;
  sectionType: SectionType;
  field: SectionTypeStructureFieldList;
  items: T[];
  onChange: (items: T[]) => void;
}

export default function SectionItemsListEditor<T extends ItemWithId>({
  title,
  sectionType,
  field,
  items,
  onChange,
}: Props<T>) {
  const [selectedItem, setSelectedItem] = useState<ItemWithId>();
  const [editModalOpen, setEditModalOpen] = useState(false);

  return (
    <div>
      <EditStructuredSectionItemModal
        item={selectedItem}
        field={field}
        open={editModalOpen}
        onClose={() => {
          setEditModalOpen(false);
          setSelectedItem(undefined);
        }}
        onSave={(item) => {
          const index = items?.findIndex((b) => b.id === selectedItem?.id);
          if (items && index != null && index !== -1) {
            const newArr = [...items];
            newArr[index] = item as T;
            console.log('newArr', newArr);
            onChange?.(newArr);
          } else {
            onChange?.([...(items || []), item as T]);
          }

          setEditModalOpen(false);
          setSelectedItem(undefined);
        }}
      />
      {/* <DynamicSectionItemEditModal<ItemWithId>
        sectionType={sectionType}
        selectedItem={selectedItem}
        items={items}
        open={editModalOpen}
        onClose={() => {
          setEditModalOpen(false);
          setSelectedItem(undefined);
        }}
        onChange={(_, __, items) => {
          onChange?.(items as T[]);
        }}
      /> */}
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {title || 'Items'}
        </label>
        <IconButton
          variant="ternary"
          onClick={() => {
            setEditModalOpen(true);
          }}
        >
          <PlusIcon className="h-4 w-4" />
        </IconButton>
      </div>
      <SortableList
        items={items ?? []}
        renderItemContent={(item) => {
          if (sectionType === 'logos') {
            return (
              <img
                key={item.id || item.url}
                src={item.image?.url ?? item.url}
                className="h-8"
              />
            );
          }
          const value =
            item.title ||
            item.name ||
            item.brandName ||
            item.body ||
            item.question ||
            item.text;
          return (
            <QuillField
              key={JSON.stringify(value)}
              value={value}
              noDesign
              readOnly
            />
          );
        }}
        renderActions={(item) => {
          return (
            <>
              <IconButton
                variant="primary"
                size="small"
                onClick={() => {
                  setSelectedItem(item);
                  setEditModalOpen(true);
                }}
              >
                <PencilIcon className="h-4 w-4" />
              </IconButton>
              <IconButton
                variant="primary"
                color="negative"
                size="small"
                onClick={() => {
                  onChange?.(items?.filter((c) => c.id !== item.id) || []);
                }}
              >
                <TrashIcon className="h-4 w-4" />
              </IconButton>
            </>
          );
        }}
        onChange={(items) => {
          onChange?.(items);
        }}
      />
    </div>
  );
}
